import axios from 'axios';
// export const BASE_URL = 'https://backend.jcgn.org/';
export const BASE_URL = 'https://backend.jcgn.org/';

// Send OTP - Sign Up for Delivery Person

export const sendOTP = async (email) => {
  console.log(email);
  try {
    const response = await axios.post(`${BASE_URL}user/sendOTP`, {
      email,
      app: 'delivery',
    });
    return response.data;
  } catch (error) {
    console.error('Error sending OTP:', error);
    throw error.response?.data || { message: 'Network Error' };
  }
};

// Verify OTP - Signup
export const verifyOTP = async ({ email, OTP }) => {
  try {
    const response = await axios.post(`${BASE_URL}user/verify`, {
      email,
      OTP,
    });
    return response.data;
  } catch (error) {
    console.error('Error verifying OTP:', error);
    throw error;
  }
};

// Register as a Delivery Person
export const registerUser = async (userData) => {
  try {
    console.log(userData);
    const response = await axios.post(`${BASE_URL}user/adduser`, userData);
    return response.data;
  } catch (error) {
    console.error('Error registering user:', error);
    throw error;
  }
};

// Password reset - send OTP to email
export const sendPasswordOTP = async (email) => {
  try {
    const response = await axios.post(`${BASE_URL}user/sendPassOtp`, {
      email,
      app: 'delivery',
    });
    return response.data;
  } catch (error) {
    console.error('Error sending password OTP:', error);
    throw error.response?.data || { message: 'Network Error' };
  }
};

// Password reset - verify OTP
export const verifyPasswordOTP = async ({ email, enteredOTP }) => {
  try {
    const response = await axios.post(`${BASE_URL}user/verifyOtp`, {
      email,
      enteredOTP,
    });
    return response.data;
  } catch (error) {
    console.error('Error verifying password OTP:', error);
    throw error.response?.data || { message: 'Network Error' };
  }
};

// Password reset - set new password
export const resetPassword = async ({ email, newPassword }) => {
  try {
    const response = await axios.post(`${BASE_URL}user/forgetPassword`, {
      email,
      newPassword,
    });
    return response.data;
  } catch (error) {
    console.error('Error resetting password:', error);
    throw error.response?.data || { message: 'Network Error' };
  }
};

export const loginUser = async (formData) => {
  const requestBody = {
    email: formData.email,
    password: formData.password,
  };

  try {
    const response = await axios.post(`${BASE_URL}user/loggin`, requestBody, {
      timeout: 10000,
    });

    if (response.data.status === true) {
      const role = response.data.data?.Role?.role;
      if (role !== 'deliver') {
        const err = new Error(
          'This account is not registered as delivery staff. Please use a delivery driver account or sign up.'
        );
        err.isRoleError = true;
        throw err;
      }
      localStorage.setItem('token', response.data.jwt);
      localStorage.setItem('userId', response.data.data.id);
      localStorage.setItem('userRole', role);
      localStorage.setItem('userEmail', response.data.data.email);
    }

    return response;
  } catch (error) {
    throw error;
  }
};
